import { AxiosInstance } from 'axios'
import { ApiResult } from '../server.api'

// Api interface
export default class AssocApeNaf2025Api {
  instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async create(target: assocApeNaf2025): Promise<ApiResult<assocApeNaf2025>> {
    return this.instance.post('/AssocApeNaf2025', target)
  }

  async delete(target: assocApeNaf2025): Promise<ApiResult<assocApeNaf2025>> {
    return this.instance.delete('/AssocApeNaf2025', { data: target })
  }
}

// Types
type assocApeNaf2025 = {
  apeId: number
  naf2025Id: number
}

export { assocApeNaf2025 }